(() => {
  const roots = document.querySelectorAll("[data-liq-faq]");
  if (!roots.length) return;

  roots.forEach((root) => {
    const items = root.querySelectorAll("[data-liq-faq-item]");

    items.forEach((item) => {
      const btn = item.querySelector("[data-liq-faq-btn]");
      const panel = item.querySelector("[data-liq-faq-panel]");
      const sign = item.querySelector("[data-liq-faq-sign]");
      if (!btn || !panel) return;

      btn.addEventListener("click", () => {
        const open = btn.getAttribute("aria-expanded") === "true";
        const next = !open;

        items.forEach((other) => {
          const oBtn = other.querySelector("[data-liq-faq-btn]");
          const oPanel = other.querySelector("[data-liq-faq-panel]");
          const oSign = other.querySelector("[data-liq-faq-sign]");
          if (!oBtn || !oPanel) return;
          oBtn.setAttribute("aria-expanded", "false");
          oPanel.hidden = true;
          if (oSign) oSign.textContent = "+";
        });

        if (next) {
          btn.setAttribute("aria-expanded", "true");
          panel.hidden = false;
          if (sign) sign.textContent = "−";
        }
      });
    });
  });
})();
